export const CHECKBOXES_CHECK_ITEM = 'syftacp/CHECKBOXES_CHECK_ITEM' as const
export const CHECKBOXES_CLEAR_ITEMS = 'syftacp/CHECKBOXES_CLEAR_ITEMS' as const
export const CHECKBOXES_UNCHECK_ITEM = 'syftacp/CHECKBOXES_UNCHECK_ITEM' as const
